// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"192":"722e1643","703":"722e1643","998":"722e1643"}[chunkId] + ".chunk.css";
};